import {
  REGISTER_LOGIN_REQUEST,
  ADD_LOGIN_REQUEST,
  UPDATE_LOGIN_REQUEST,
  DELETE_LOGIN_REQUEST,
  GET_LOGIN_REQUEST,
  GET_LOGINS_LIST_REQUEST,
  VALIDATE_PASSWORD_REQUEST,
  GET_LOGIN_SUCCESS,
  GET_LOGINS_LIST_SUCCESS,
  DELETE_LOGIN_SUCCESS,
  ADD_LOGIN_SUCCESS,
  REGISTER_LOGIN_SUCCESS,
  UPDATE_LOGIN_SUCCESS,
  VALIDATE_PASSWORD_SUCCESS,
  GET_LOGINS_LIST_FAIL,
  GET_LOGIN_FAIL,
  DELETE_LOGIN_FAIL,
  ADD_LOGIN_FAIL,
  UPDATE_LOGIN_FAIL,
  REGISTER_LOGIN_FAIL,
  VALIDATE_PASSWORD_FAIL,
  ADD_LOGIN_PENDING,
  ADD_LOGIN_FULFILLED,
  ADD_LOGIN_REJECTED,
  CREATE_NEW_LOGIN,
  DELETE_LOGIN_PENDING,
  DELETE_LOGIN_FULFILLED,
  GET_LOGIN_PENDING,
  GET_LOGIN_FULFILLED,
  GET_LOGIN_REJECTED,
  GET_LOGINS_LIST_PENDING,
  GET_LOGINS_LIST_FULFILLED,
  GET_LOGINS_LIST_REJECTED,
  REGISTER_LOGIN_PENDING,
  REGISTER_LOGIN_FULFILLED,
  REGISTER_LOGIN_REJECTED,
  UPDATE_LOGIN_PENDING,
  UPDATE_LOGIN_FULFILLED,
  UPDATE_LOGIN_REJECTED,
  VALIDATE_PASSWORD_PENDING,
  VALIDATE_PASSWORD_FULFILLED,
  VALIDATE_PASSWORD_REJECTED,


  DEFAULTLOGINENTRY,
  
  
  
  /*** PAGINATION --- START */
  GET_LOGINS_LIST_PAGINATION_REQUEST,
  GET_LOGINS_LIST_PAGINATION_PENDING,
  GET_LOGINS_LIST_PAGINATION_FULFILLED,
  GET_LOGINS_LIST_PAGINATION_SUCCESS,
  GET_LOGINS_LIST_PAGINATION_REJECTED,
  GET_LOGINS_LIST_PAGINATION_FAIL,
  /*** PAGINATION --- END */

  

  /*** SPECIFIC TO THIS APP --- START */
  ADD_LOGIN_PROGRAM_REQUEST,
  ADD_LOGIN_PROGRAM_SUCCESS,
  ADD_LOGIN_PROGRAM_FAIL,

  DELETE_LOGIN_PROGRAM_REQUEST,
  DELETE_LOGIN_PROGRAM_SUCCESS,
  DELETE_LOGIN_PROGRAM_FAIL,

  ADD_LOGIN_PROGRAM_FULFILLED,
  DELETE_LOGIN_PROGRAM_FULFILLED,
  GET_LOGIN_PROGRAMSLIST_LIST_FULFILLED,
  GET_LOGIN_PROGRAMSNOTLIST_LIST_FULFILLED,
  GET_LOGIN_PROGRAMSLIST_LIST_SUCCESS,
  GET_LOGIN_PROGRAMSNOTLIST_LIST_SUCCESS,
  /*** SPECIFIC TO THIS APP --- END */


} from '../actions/action-constants';
const initialState = {
  addSuccess: false,
  deleteSuccess: false,
  registerSuccess: false,
  updateSuccess: false,

  isAuthenticated: false,
  isAuthenticating: true,

  loading: false,
  loadingList: false,
  validatingPassword: false,

  login: [],
  logins: [],
  loginroles: [],

  dataEntry: {},
  dataList: [],
  referralEntry: [],

  errors: [],
  errorInvalidEntry: false,

  // paginationList: [],
  paginationDataList: [],
  paginationPage: 0,
  paginationTotalCount: 0,

  /*** SPECIFIC TO THIS APP --- START */
  programsList: [],
  programsNotList: [],
  /*** SPECIFIC TO THIS APP --- END */
  
};
const reducerLogins = (state = initialState, action) => {
  var dataEntry;
  var dataList;

  /*** SPECIFIC TO THIS APP --- START */
  // var paginationList;
  var paginationDataList;
  var paginationPage;
  var paginationTotalCount;
  /*** SPECIFIC TO THIS APP --- END */
                                            
  switch (action.type) {
    case CREATE_NEW_LOGIN:
      dataEntry =
        typeof action.payload.login !== 'undefined' &&
        action.payload.login !== null
          ? action.payload.login
          : [];
      state = {
        ...state,
        loadingList: false,
        errorInvalidEntry: false,
        // returnedEntry: dataEntry,
        login: dataEntry
      };
      break;
    case REGISTER_LOGIN_REQUEST:
    case ADD_LOGIN_REQUEST:
    case UPDATE_LOGIN_REQUEST:
    case DELETE_LOGIN_REQUEST:
    case GET_LOGIN_REQUEST:
    case REGISTER_LOGIN_PENDING:
    case ADD_LOGIN_PENDING:
    case UPDATE_LOGIN_PENDING:
    case DELETE_LOGIN_PENDING:
    case GET_LOGIN_PENDING:
      state = {
        ...state,
        loading: true
      };
      break;
    case GET_LOGINS_LIST_PAGINATION_REQUEST:
    case GET_LOGINS_LIST_PAGINATION_PENDING:
    case GET_LOGINS_LIST_REQUEST:
    case GET_LOGINS_LIST_PENDING:
      state = {
        ...state,
        loadingList: true
      };
      break;
    case VALIDATE_PASSWORD_REQUEST:
    case VALIDATE_PASSWORD_PENDING:
      state = {
        ...state,
        validatingPassword: true
      };
      break;
    case GET_LOGINS_LIST_SUCCESS:
    case GET_LOGINS_LIST_FULFILLED:
      dataList = typeof action.payload.data !== 'undefined' && action.payload.data !== null ? action.payload.data : [];
      state = {
        ...state,
        loading: false,
        loadingList: false,
        addSuccess: false,
        registerSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        errorInvalidEntry: false,
        logins: dataList,
      };
      break;
    case GET_LOGIN_SUCCESS:
    case GET_LOGIN_FULFILLED:
      var invalidEntry = false;
      if (Object.entries(action.payload.logins).length > 0) {
        dataEntry = typeof action.payload.logins !== 'undefined' && action.payload.logins !== null ? action.payload.logins : [];
      } else {
        dataEntry = {};
        invalidEntry = true;
      }
      state = {
        ...state,
        loading: false,
        loadingList: false,
        addSuccess: false,
        registerSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        errors: [],
        errorInvalidEntry: invalidEntry,
        login: dataEntry,
        returnedEntry: dataEntry,
      };
      break;
    case DELETE_LOGIN_PROGRAM_SUCCESS:  /*** SPECIFIC TO THIS APP --- START */
    case DELETE_LOGIN_PROGRAM_FULFILLED:  /*** SPECIFIC TO THIS APP --- START */
    case DELETE_LOGIN_SUCCESS:
    case DELETE_LOGIN_FULFILLED:
      state = {
        ...state,
        loading: false,
        loadingList: false,
        deleteSuccess: true,
        errorInvalidEntry: false
      };
      break;
    case ADD_LOGIN_PROGRAM_SUCCESS:  /*** SPECIFIC TO THIS APP --- START */
    case ADD_LOGIN_PROGRAM_FULFILLED:  /*** SPECIFIC TO THIS APP --- START */
    case ADD_LOGIN_SUCCESS:
    case ADD_LOGIN_FULFILLED:
      state = {
        ...state,
        loading: false,
        loadingList: false,
        addSuccess: true,
        errorInvalidEntry: false
      };
      break;
    case REGISTER_LOGIN_SUCCESS:
    case REGISTER_LOGIN_FULFILLED:
      state = {
        ...state,
        loading: false,
        loadingList: false,
        registerSuccess: true,
        errorInvalidEntry: false
      };
      break;  
    case UPDATE_LOGIN_SUCCESS:
    case UPDATE_LOGIN_FULFILLED:
      state = {
        ...state,
        loading: false,
        loadingList: false,
        updateSuccess: true,
        errorInvalidEntry: false
      };
      break;
    case VALIDATE_PASSWORD_SUCCESS:
    case VALIDATE_PASSWORD_FULFILLED:
      state = {
        ...state,
        loading: false,
        loadingList: false,
        validatingPassword: false,
        errorInvalidEntry: false
      };
      break;

      case GET_LOGINS_LIST_PAGINATION_FAIL:
        case GET_LOGINS_LIST_PAGINATION_REJECTED:
          case GET_LOGINS_LIST_FAIL:
    case GET_LOGIN_FAIL:
    case DELETE_LOGIN_FAIL:
    case ADD_LOGIN_FAIL:
    case UPDATE_LOGIN_FAIL:
    case REGISTER_LOGIN_FAIL:
    case VALIDATE_PASSWORD_FAIL:
    case GET_LOGINS_LIST_REJECTED:
    case GET_LOGIN_REJECTED:
    case ADD_LOGIN_REJECTED:
    case UPDATE_LOGIN_REJECTED:
    case REGISTER_LOGIN_REJECTED:
    case VALIDATE_PASSWORD_REJECTED:
      state = {
        ...state,
        errorInvalidEntry: true,
        errors: [action.payload.response]
      };
      break;





    /*** PAGINATION --- START */
    case GET_LOGINS_LIST_PAGINATION_SUCCESS:
    case GET_LOGINS_LIST_PAGINATION_FULFILLED:
      // console.log("11-22 = ", action.payload.data);
      // data: (10) [{…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
      // next: {page: 1, limit: 10}
      // page: 0
      // totalCount: 32
        if (typeof action.payload.data !== 'undefined' && action.payload.data !== null) {
        paginationDataList = action.payload.data.data
        paginationPage = action.payload.data.page
        paginationTotalCount = action.payload.data.totalCount
        }else{
        paginationDataList = []
        paginationPage = 0
        paginationTotalCount = 0
        }

        state = {
        ...state,
        loading: false,
        loadingList: false,
        addSuccess: false,
        registerSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        errorInvalidEntry: false,
              // dataList: dataList
              // paginationList: paginationList
        paginationDataList: paginationDataList,
        paginationPage: paginationPage,
        paginationTotalCount: paginationTotalCount,
      };
      break;
/*** PAGINATION --- END */








    /*** SPECIFIC TO THIS APP --- START */
    case GET_LOGIN_PROGRAMSLIST_LIST_SUCCESS:
    case GET_LOGIN_PROGRAMSLIST_LIST_FULFILLED:
      dataList =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.programslist
          : [];
      state = {
        ...state,
        loading: false,
        loadingList: false,
        addSuccess: false,
        registerSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        errorInvalidEntry: false,
        programsList: dataList
      };
      break;
    case GET_LOGIN_PROGRAMSNOTLIST_LIST_SUCCESS:
    case GET_LOGIN_PROGRAMSNOTLIST_LIST_FULFILLED:
      dataList =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.programslist
          : [];
      state = {
        ...state,
        loading: false,
        loadingList: false,
        addSuccess: false,
        registerSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        errorInvalidEntry: false,
        programsNotList: dataList
      };
      break;
    /*** SPECIFIC TO THIS APP --- END */





    default:
      return state;
  }
  return state;
};
export default reducerLogins;

